import { consoleLog } from 'utils/simpleLogger'
import { useNorthCapitalApi } from './useNorthCapitalAPI'

const usePayments = () => {
  const { createTrade, initiateCardPayment } = useNorthCapitalApi()

  const initiateCCPayment = async (accessToken: string, accountId: string, totalShares: number) => {
    consoleLog('Creating trade...')
    const tradeRes = await createTrade(accountId, 'CREDITCARD', totalShares, accessToken)

    consoleLog('Creating initiating payment...')
    const res = await initiateCardPayment(accountId, Number(tradeRes.data.purchaseDetails[1][0].tradeId), accessToken)
    return res
  }
  return {
    initiateCCPayment,
  }
}

export default usePayments
